import React from "react";

export default function AboutCopy() {
  return (
    <>
      <strong style={{ fontSize: "18px" }}>We are Mark and Sterling</strong>, two best friends discussing our favorite
      forms of entertainment. <br />
      <br />
      Every Monday on YouTube we dive deep into an episode of great television and then break it down in a conversation
      together. We cover shows from our favorite genres such as Science Fiction, Fantasy, Drama, and more. We also
      create short videos and posts across many platforms that celebrate a wider range of entertainment we enjoy such as
      movies, music, video games, and books. <br />
      <br />
      So if you enjoy great entertainment and want to check out our content or join the conversation, then connect with
      us on one of the social platforms below.
      <br />
      <br />
      #JourneyWithUs
    </>
  );
}
